jQuery(function ($) {

    // Hide form initially
    $("#gform_1").hide();

    // Ensure minimum value for meter quantity
    document.getElementById("meterQty").addEventListener("change", function () {
        if (this.value !== "" && Number(this.value) < 10) {
            this.value = 10;
        }
    });

    // Handle enquire button click
    $(".enquire-btn").click(function () {
        $(".meter-calculator").hide();
        $("#gform_1").show();

        var selectedText =
            $(this).closest(".card").find("h5").text() +
            " - Qty: " +
            $("#meterQty").val();

        $("#input_1_7").val(selectedText);
    });

    var $container = $("#meterQtyContainer");
    var originalTop = $container.offset().top;

    $(window).on("scroll resize", function () {
        var scrollTop = $(window).scrollTop();
        var triggerPoint = scrollTop + ($(window).height() * 0.5);

        if (triggerPoint > originalTop) {
            $container.addClass("fixed");
        } else {
            $container.removeClass("fixed");
        }
    });

});